import { createContext, useContext, useEffect, useState } from "react";
import { apiLogin, apiMe, setToken, clearToken, getToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  // null = checking, false = not authed, object = authed
  const [user, setUser] = useState(null);

  useEffect(() => {
    const check = async () => {
      if (!getToken()) {
        setUser(false);
        return;
      }
      try {
        const me = await apiMe();
        setUser(me);
      } catch {
        clearToken();
        setUser(false);
      }
    };
    check();
  }, []);

  const login = async (username, password) => {
    const data = await apiLogin(username, password);
    setToken(data.access_token);
    setUser({ username: data.username });
    return data;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
